import React from "react";
import Applet from "../../Applet";
import AdminWorkGroupPositionTable from "../../../../components/Administration/AdminWorkGroupPositionTable";

class AdminWorkGroupPositionTableApplet extends Applet {

    render() {
        return <AdminWorkGroupPositionTable applet={this}
                                   pageSize={this.state.PageSize}
                                   placement={this.state.Placement}
                                   columns={this.state.Columns}
                                   title="Positions"
                                   enterpriseComponent={this.getEnterpriseComponent()}
                                   sort={this.state.Sort}
                                   menu={this.state.Menu}
                                   rowHeight={this.state.RowHeight}
        />;
    }

    state = {
        Name: "AdminWorkGroupPositionTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Add Position To Work Group",
                    value: "New Position",
                },

                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 55,
        PageSize: {
            "default": 5,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 10,
            "lx": 10,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Name",
                },
                {
                    id: "ParentPositionName",
                },
                {
                    id: "PrimaryEmployeeName",
                },
                {
                    id: "Actions",
                },
            ],
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Name",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "ParentPositionName",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Parent Position Name",
            },
            {
                id: "PrimaryEmployeeName",
                width: 250,
                cellRenderer: "Employee Name Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Primary Employee",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }],
            },
        ],
    };
}

export default AdminWorkGroupPositionTableApplet;
